import { render, staticRenderFns } from "./tile-head.vue?vue&type=template&id=740a128e"
import script from "./tile-head.vue?vue&type=script&lang=ts"
export * from "./tile-head.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('740a128e')) {
      api.createRecord('740a128e', component.options)
    } else {
      api.reload('740a128e', component.options)
    }
    module.hot.accept("./tile-head.vue?vue&type=template&id=740a128e", function () {
      api.rerender('740a128e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tile/tile-head.vue"
export default component.exports